import AGENT_TASK_STATE from "./agentTask";

const BLUEPRINTS_CONFIG = {
  LIST_TAGS_LIMIT: 2,
  SUMMARY_TAGS_LIMIT: 30,
};

const BLUEPRINT_GENERATION_CONFIG = {
  POLLING_INTERVAL: 5000,
};

const MISSION_ROLE_TEMPLATE_STATE = {
  published: "PUBLISHED",
  unpublished: "UNPUBLISHED",
};

const toTagValues = (tags) => (tags || []).map(({ id, name }) => ({ id, name }));

/**
 * What the blueprint form starts from: an existing blueprint's own fields, or empty for a new one.
 */
const getBlueprintFormValues = (template) => ({
  name: template?.name,
  disciplines: toTagValues(template?.disciplines),
  primarySkills: toTagValues(template?.primarySkills),
});

const isBlueprintPublished = (template) => template?.state === MISSION_ROLE_TEMPLATE_STATE.published;

const getBlueprintGenerationState = (template) => template?.latestBlueprintGenerationAgentTask?.state;

const isBlueprintGenerating = (template) => getBlueprintGenerationState(template) === AGENT_TASK_STATE.processing;

const isBlueprintGenerationCompleted = (template) =>
  getBlueprintGenerationState(template) === AGENT_TASK_STATE.completed;

const isBlueprintGenerationFailed = (template) => getBlueprintGenerationState(template) === AGENT_TASK_STATE.failed;

const isBlueprintAgentTask = (template) => isBlueprintGenerating(template) || isBlueprintGenerationFailed(template);

const hasBlueprintGenerationEnded = (template) =>
  Boolean(getBlueprintGenerationState(template)) && !isBlueprintGenerating(template);

export {
  BLUEPRINTS_CONFIG,
  BLUEPRINT_GENERATION_CONFIG,
  MISSION_ROLE_TEMPLATE_STATE,
  getBlueprintFormValues,
  isBlueprintPublished,
  isBlueprintGenerating,
  isBlueprintGenerationCompleted,
  isBlueprintGenerationFailed,
  hasBlueprintGenerationEnded,
  isBlueprintAgentTask,
};
